module.exports = __webpack_public_path__ + "img/will-gifts.685efe61.svg";